module.exports = __webpack_public_path__ + "img/pop-bg.e65379b1.png";